import './styledComponents.css';
import React, { useEffect, useRef } from 'react';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

const Input = ({ inputValue, resetInput, setResetInput }) => {
	const inputRef = useRef(null);
	useEffect(() => {
		if (resetInput){
			inputRef.current.classList.add('input-maze-reset-value');
			setTimeout(() => {
				inputRef.current.value = '';
				inputRef.current.classList.remove('input-maze-reset-value');
				setResetInput(false);
			}, 1000);
		}
		// eslint-disable-next-line
	}, [resetInput]);
	return (
		<>
			<input
				ref={inputRef}
				className="maze-input-result"
				onChange={(e) => {
					inputValue(e.target.value);
				}}
			/>
			<button type="submit" className='maze-input-submit'>
				{/* <div>{VpnKeyIcon}</div> */}
				<VpnKeyIcon></VpnKeyIcon>
			</button>
		</>
	);
};

export default Input;
